import { findAnimationById } from 'Pods/ThreeDStudio/Services/Constants/animations'
import { MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Inverse of parseMeshyAnimationProData. Builds an openedModel-shaped payload
 * from the current animateSettings so the just-submitted run can be reopened
 * without an extra API round-trip.
 *
 * The store holds a local library slug but the run row holds Meshy's numeric id,
 * so the slug is resolved here - the optimistic payload has to look exactly like
 * the persisted one or reopening the run would land on a different animation.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseMeshyAnimationProData
 */
export const buildMeshyAnimationProFromState = (state, id) => {
  const { animationId } = state.animateSettings || {}
  const { actionId } = findAnimationById(animationId) || {}

  return {
    id,
    providerKey: PROVIDER.MESHY,
    providerModelId: MODEL_ID.MESHY_ANIMATION_PRO,
    providerRunAttributes: {
      ...(actionId != null && { action_code: actionId }),
    },
  }
}
